import { IUrlSeedDisplay } from '../../../../interfaces/UrlSeedDisplay';

/**
 * Returns the IDs from `selectedSeeds` that still correspond to a row in
 * `seeds`. Used to feed `EvTable`'s `selectRow.selected` prop safely.
 *
 * Why this exists: `EvTable` (via react-bootstrap-table-next) maps each
 * selected ID back to a row with `data.find(row => row.id === selectedId)`.
 * If the ID is not present, `.find` returns `undefined`, and EvTable then
 * reads `.id` on that `undefined` and throws — taking down the whole subtree.
 *
 * This filter prevents that crash whenever `selectedSeeds` outlives the
 * `seeds` array it was selected from (e.g. switching between list and crawl
 * modes in the property settings page).
 */
export const getValidSelectedIds = (
	selectedSeeds: IUrlSeedDisplay[],
	seeds: IUrlSeedDisplay[]
): number[] => {
	const seedIds = new Set(seeds.map((seed) => seed.id));
	return selectedSeeds.filter((seed) => seedIds.has(seed.id)).map((seed) => seed.id);
};
